import { createContext, ReactElement, ReactNode, useContext } from 'react';
import { NewCasinoGamesFetchingParams } from 'interfaces/new-casino';
import { CasinoGamesFetchingParamsActionType } from '../state/reducer';

export type CasinoGamesFetchParamsProviderProps = {
  children: ReactNode;
  value: {
    fetchParams: Partial<NewCasinoGamesFetchingParams>;
    dispatchFetchParams: (action: {
      type: CasinoGamesFetchingParamsActionType;
      payload?: Partial<NewCasinoGamesFetchingParams>;
    }) => void;
  };
};

const CasinoGamesFetchParamsContext = createContext<
  CasinoGamesFetchParamsProviderProps['value']
>({
  fetchParams: {},
  dispatchFetchParams: () => {}
});

export const CasinoGamesFetchParamsProvider = (
  props: CasinoGamesFetchParamsProviderProps
): ReactElement => {
  return (
    <CasinoGamesFetchParamsContext.Provider value={props.value}>
      {props.children}
    </CasinoGamesFetchParamsContext.Provider>
  );
};

export const useCasinoGamesFetchParamsValues =
  (): CasinoGamesFetchParamsProviderProps['value'] => {
    return useContext(CasinoGamesFetchParamsContext);
  };
